import { useWatch } from 'react-hook-form';

import { useEffect } from 'react';
import { filterPillText, useModelFilterField } from '../../../form';
import { useModelFiltersContext } from '@rhino-project/core/hooks';
import { FilterString } from '../../../Filter';

export const ModelFilterString = ({
  path,
  ...props
}: {
  path: string;
  [key: string]: unknown;
}) => {
  const { attribute, operator, operatorPath, ...rest } =
    useModelFilterField(path);

  const watch = useWatch({ name: operatorPath });
  const { setPill } = useModelFiltersContext();

  // If the user clears the input, we want to reset the pill
  useEffect(() => {
    if (watch !== undefined && watch !== '')
      setPill(operatorPath, filterPillText(attribute, operator, watch));
  }, [attribute, operator, operatorPath, setPill, watch]);

  return (
    <FilterString
      path={operatorPath}
      minLength={attribute.minLength}
      maxLength={attribute.maxLength}
      {...rest}
      {...props}
    />
  );
};
